// wondr grain — PDP description → numbered design cards (design-exact internals)
(() => {
  'use strict';
  const wrap = document.querySelector('[data-pdp-split]');
  if (!wrap) return;
  const body = wrap.querySelector('.pdp-body');
  if (!body) return;
  const SECTIONS = ['Description', 'Ingredients', 'Usage info', 'Benefits', 'Storage info'];
  const SNOW = '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M12 2v20M4.9 5.5l14.2 13M19.1 5.5l-14.2 13M12 2l-2 2.5M12 2l2 2.5M12 22l-2-2.5M12 22l2-2.5"/></svg>';
  const nodes = Array.from(body.children);
  const cards = [];
  let current = null;
  nodes.forEach((node) => {
    const strong = node.querySelector && node.querySelector(':scope > strong:first-child');
    const label = strong ? strong.textContent.trim().replace(/\s+—.*$/, '') : '';
    const idx = SECTIONS.findIndex((s) => label.toLowerCase().startsWith(s.toLowerCase()));
    if (node.tagName === 'P' && idx !== -1) {
      current = { title: SECTIONS[idx], num: String(idx + 1).padStart(2, '0'), sub: strong.textContent.trim(), parts: [] };
      cards.push(current);
      const clone = node.cloneNode(true);
      clone.querySelector('strong').remove();
      const html = clone.innerHTML.replace(/^\s*(<br\s*\/?>)?\s*/, '');
      if (html.trim()) current.parts.push('<p>' + html + '</p>');
    } else if (current) {
      current.parts.push(node.outerHTML);
    }
  });
  if (cards.length < 3) return;

  const transform = (c) => {
    let html = c.parts.join('');
    if (c.title === 'Ingredients') {
      html = html.replace(/\.\s*(Organically grown[^<]*)<\/p>/, '.</p><p class="ic-sub">$1</p>');
    } else if (c.title === 'Usage info') {
      html = html.replace(/<ol(\s|>)/, '<ol class="steps"$1');
    } else if (c.title === 'Benefits') {
      html = html.replace(/<ul(\s|>)/, '<ul class="story-points"$1')
                 .replace(/<li>/g, '<li><span class="tick">\u2713</span>');
    } else if (c.title === 'Storage info') {
      html = html.replace(/<p>\s*(.+?\.)\s*(.*?)<\/p>/s, (m, note, rest) => {
        let out = '<p class="storage-note" style="margin:0 0 10px">' + SNOW + note + '</p>';
        if (rest && rest.trim()) out += '<p>' + rest.trim() + '</p>';
        return out;
      });
    }
    return html;
  };

  wrap.innerHTML = cards.map((c) => {
    const subtitle = c.sub.length > c.title.length + 3
      ? `<p class="ic-sub" style="margin-bottom:10px">${c.sub.replace(/^[^—]*—\s*/, '')}</p>` : '';
    return `<div class="info-card reveal in-view" id="${c.title.split(' ')[0].toLowerCase()}">
      <h3><span class="ic-num">${c.num}</span>${c.title}</h3>${subtitle}${transform(c)}
    </div>`;
  }).join('');
})();
